import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-default-navigate',
  standalone: true,
  imports: [],
  template: '',
  styles: [],
})
export class DefaultNavigateComponent {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const targetRoute = this.route.snapshot.data['landing'];
    this.router.navigateByUrl(targetRoute);
  }
}
